import _ from 'lodash';

import * as constants from './FlashCardLanding.constants';
import * as services from './FlashCardLanding.service';

const state = {
  flashCardList: {},
  isRequest: false,
};

const mutations = {
  [constants.GET_COURSE_FLASH_CARD_LIST_SUCCESS](state, flashCardList) {
    if (undefined !== flashCardList && null !== flashCardList) {
      state.flashCardList = flashCardList;
    }
  },

  [constants.SET_IS_REQUEST_STATUS](state, status) {
    state.isRequest = status;
  },
};

const actions = {
  async getCourseFlashCardList({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.getCourseFlashCardList(payload);
    commit(constants.GET_COURSE_FLASH_CARD_LIST_SUCCESS, res.data.data);
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },
};

const getters = {
  flashCardList: (state) => {
    const { flashCardList } = state;
    let countFavoriteCardByCourse = flashCardList.countFavoriteCardByCourse;
    countFavoriteCardByCourse = !countFavoriteCardByCourse ? 0 : countFavoriteCardByCourse;
    return {
      ...flashCardList,
      countFavoriteCardByCourse,
      cardList: _.filter(flashCardList.cardList, (card) => -1 !== card.cardId),
    };
  },

  isFlashCardUnpaid: (state, getters) => {
    return 1 === getters.flashCardList.flashCardStatus;
  },

  isFlashCardWaiting: (state, getters) => {
    return 2 === getters.flashCardList.flashCardStatus;
  },

  isFlashCardAvailable: (state, getters) => {
    return !getters.isFlashCardUnpaid && !getters.isFlashCardWaiting;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
